<template>
	<div class="online-service-box">
		<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=3235393303&amp;site=qq&amp;menu=yes">
			<img border="0" class="serviceImg" src="../assets/img/serviceQQ.png" object-fit = contain alt="点击这里给我发消息" title="点击这里给我发消息" />
		</a> 
	</div>
</template>

<script>
	export default{
		name: 'onlineService'
	}
</script>

<style scoped>
	.online-service-box {
		width: 150px;
		position: fixed;
		top: 500px;
		right: 10px;
	}
	.serviceImg{
		width: auto;  
	    height: auto;  
	    max-width: 100%;  
	    max-height: 100%;
	}
	@media screen and (min-width: 320px) and (max-width: 1024px) {
		.online-service-box {
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService.vue